import React from "react";

import {
  CABINET_MODEL_LABELS,
  CabinetModel,
  cabinetModelOf,
} from "./deviceTypeConfig";

/** `К2.6`: у СМБ та же модель 9/15, но подписи свои. */
const SMB_MODEL_LABELS: Record<CabinetModel, string> = {
  9: "СМБ-9",
  15: "СМБ-15",
};

/** Подпись модели для карточки: у МДБН — `МДБН-9`, у СМБ — `СМБ-9`. */
export function cabinetModelText(
  deviceType: string | null | undefined,
  value: unknown,
): string {
  const model = cabinetModelOf(value);

  return deviceType === "smb"
    ? SMB_MODEL_LABELS[model]
    : CABINET_MODEL_LABELS[model];
}

interface CabinetModelSwitchProps {
  isRoot: boolean;
  deviceType?: string | null;
  value: unknown;
  onChange: (model: CabinetModel) => void;
}

/**
 * `К2.6`: модель шкафа — в строке «СТАНЦИИ МОДУЛЯ», а не отдельным блоком.
 *
 * Переключатель из двух кнопок занимает меньше места, чем выпадающий список с
 * подписью: блок «МОДЕЛЬ ШКАФА:» больше не нужен. Меняет только root; остальным
 * модель видна текстом — по ней понятно, почему станций девять, а не пятнадцать.
 */
export const CabinetModelSwitch = ({
  isRoot,
  deviceType,
  value,
  onChange,
}: CabinetModelSwitchProps) => {
  const model = cabinetModelOf(value);

  if (!isRoot) {
    return (
      <span className="cabinet_model_text">
        шкаф {cabinetModelText(deviceType, model)}
      </span>
    );
  }

  return (
    <span className="cabinet_model_switch">
      <span className="cabinet_model_label">шкаф</span>
      <span role="group" aria-label="Модель шкафа" className="cabinet_model_group">
        {([9, 15] as CabinetModel[]).map((item) => (
          <button
            key={item}
            type="button"
            className={`cabinet_model_button${
              model === item ? " cabinet_model_button--active" : ""
            }`}
            aria-pressed={model === item}
            onClick={() => onChange(item)}
          >
            {item}
          </button>
        ))}
      </span>
    </span>
  );
};
